//
//
//
//
//
//
//

import i18n from "@/utils/i18n";
import propertyMixin from "@/components/form-designer/setting-panel/property-editor/propertyMixin";
export default {
  name: "maxLength-editor",
  mixins: [i18n, propertyMixin],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  },
  computed: {
    maxLength: {
      get: function get() {
        return this.optionModel['maxLength'];
      },
      set: function set(newValue) {
        if (!newValue || isNaN(newValue)) {
          this.optionModel.maxLength = null;
        } else {
          this.optionModel.maxLength = Number(newValue);
        }
      }
    }
  }
};